import { formatSsn, P, Stack, Text, useText } from "@sveabank/cc-common";
import { useSelector } from "react-redux";
import CheckboxCard from "../../../components/checkbox-card";
import { usePageContext } from "../../../hooks/context";
import { selectPossibleGuarantors } from "../../../slices/guarantorSlice";
import { useSignInformation } from "../hooks/hooks";

type Props = {
	applicantNationalId: string;
};

const AddGuarantorBox = ({ applicantNationalId }: Props) => {
	const [t, texts] = useText();
	const { handleGuarantorCheck, onRemoveGuarantor, guarantors } =
		usePageContext(useSignInformation);
	const possibleGuarantors = useSelector(selectPossibleGuarantors);

	return (
		<Stack wrap direction="row" gap={4}>
			{possibleGuarantors.map((guarantor) => {
				const persistedGuarantor = guarantors.find((g) => g.nationalId === guarantor.nationalId);
				const canBeGuarantor = persistedGuarantor ? persistedGuarantor.accepted : true;
				return (
					<CheckboxCard
						key={guarantor.nationalId}
						checked={guarantor.checked}
						onChange={() => {
							handleGuarantorCheck(guarantor.nationalId, possibleGuarantors);
						}}
						disabled={!canBeGuarantor}
						onRemove={
							guarantor.guarantorType === "external"
								? () => {
										onRemoveGuarantor(guarantor, possibleGuarantors);
									}
								: undefined
						}
					>
						<P>
							<Text bold>
								{guarantor.names.firstNames} {guarantor.names.lastNames}
							</Text>{" "}
							{applicantNationalId === guarantor.nationalId && t(texts.common.you)}
						</P>
						<div>{formatSsn(guarantor.nationalId)}</div>
						{!canBeGuarantor && (
							<Text className="text-text-error text-sm">
								Personen kan inte agera borgenär i denna ansökan
							</Text>
						)}
					</CheckboxCard>
				);
			})}
		</Stack>
	);
};

export default AddGuarantorBox;
